// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3C7Dx","footer":"ModalInfo_footer__eK5ep"};